import * as THREE from 'three';
import { CSS3DRenderer, CSS3DObject } from 'three/examples/jsm/renderers/CSS3DRenderer.js';
import Experience from '../Experience';
import { plane } from 'three/examples/jsm/Addons.js';
import EventEmitter from '../Utils/EventEmitter';

const SCREEN_SIZE = {
    width: 1200, // 屏幕宽度
    height: 960 // 屏幕高度
}

export default class Display extends EventEmitter {
    constructor() {
        super();
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.debug = this.experience.debug;
        this.resources = this.experience.resources;

        this.cssScene = this.experience.cssScene; // CSS3D场景
        this.displayMesh = null;
        this.createDisplayMesh();

    }



    createDisplayMesh() {
        // 创建遮罩平面（用于遮挡后面的物体）

        // screen rotaiton (-1.5708, -1.4644, -1.5708) in room space
        //screen center x (-1.0368, y 3.4505, z -2.2477) in room space
        // const geometry = new THREE.PlaneGeometry(-1.0368, 3.4505, -2.2477);


        const geometry = new THREE.PlaneGeometry(1, 1);

        const material = new THREE.MeshLambertMaterial({
            color: 0xffffff,
            opacity: 0.1,
            transparent: true,
            side: THREE.DoubleSide
        });
        this.displayMesh = new THREE.Mesh(geometry, material);
        this.displayMesh.position.set(-1.0368, 3.4505, -2.2477); // 设置显示屏位置

        const container = document.createElement('div');
        container.id = 'display-container'; // 设置容器 ID
        container.style.width = SCREEN_SIZE.width + 'px';
        container.style.height = SCREEN_SIZE.height + 'px';
        container.style.position = 'absolute';
        container.style.top = '0px';
        container.style.zIndex = '100'; // 确保在其他元素之上
        container.style.pointerEvents = 'none'; // 禁用交互，提升性能
        container.style.willChange = 'transform'; // 启用硬件加速

        // 创建 iframe
        const iframe = document.createElement('iframe');
        iframe.id = 'display-iframe';
        iframe.src = 'https://os.yuminghuang.com';

        iframe.style.border = 'none';
        // 透明边框
        // iframe.style.backgroundColor = 'transparent'; // 设置背景颜色为透明
        iframe.style.position = 'absolute'; // 绝对定位
        iframe.style.top = '100px'; // 设置顶部位置
        iframe.style.left = '100px'; // 设置左侧位置
        iframe.style.transform = 'translateZ(0)'; // 启用硬件加速，可能有助于性能
        iframe.style.width = (SCREEN_SIZE.width - 200) + 'px'; // 减去边距
        iframe.style.height = (SCREEN_SIZE.height - 200) + 'px'; // 减去边距
        iframe.style.pointerEvents = 'none'; // 首先禁用交互，提升性能
        iframe.style.zIndex = '100';
        iframe.style.willChange = 'auto';
        //降低 iframe 的渲染频率、
        // 降低亮度
        iframe.style.filter = 'brightness(0.8)'; // 降低亮度，避免过于刺眼

        iframe.style.visibility = 'hidden'; // 初始隐藏 iframe，等待加载完成后再显示
        container.appendChild(iframe);
        // 创建 CSS3D 对象
        this.css3dObject = new CSS3DObject(container);
        iframe.addEventListener('load', () => {

            this.onIframeLoad(); // iframe 加载完成后调用
            // // 将 iframe 添加到容器中
            this.iframe = iframe; // 保存 iframe 引用
            this.trigger('ready'); // 触发 ready 事件

            
        }); // 监听加载完成事件


        

        this.css3dObject.position.copy(this.displayMesh.position); // 复制显示屏的位置


        // this.css3dObject.rotation.copy(this.displayMesh.rotation); // 复制显示屏的旋转
        this.css3dObject.rotation.set(-1.5708, -1.4644, -1.5708); // 设置 CSS3D 对象的旋转



        this.css3dObject.updateMatrixWorld(); // 更新矩阵以应用位置和旋转
        this.css3dObject.scale.setScalar(0.0018); // 设置缩放比例
        // 根据 displayMesh 的几何体大小调整 CSS3DObject 的缩放


        this.cssScene.add(this.css3dObject); // 将 CSS3D 对象添加到 CSS3D 场景中


    }

    onIframeLoad() {

        setTimeout(() => {
            this.iframe.style.visibility = 'visible'; // 显示 iframe

        })
            , 100
    }

    setupDisplay() {

    }

    setupDebug() {
        this.debugFolder = this.debug.ui.addFolder('Display');

        // 位置控制
        this.debugFolder.add(this.displayMesh.position, 'x').min(-5).max(5).step(0.01)
            .name('Position X').onChange(() => this.updateCSS3DPosition());
        this.debugFolder.add(this.displayMesh.position, 'y').min(-5).max(5).step(0.01)
            .name('Position Y').onChange(() => this.updateCSS3DPosition());
        this.debugFolder.add(this.displayMesh.position, 'z').min(-5).max(5).step(0.01)
            .name('Position Z').onChange(() => this.updateCSS3DPosition());

        // 旋转控制
        this.debugFolder.add(this.displayMesh.rotation, 'x').min(-Math.PI).max(Math.PI).step(0.01)
            .name('Rotation X').onChange(() => this.updateCSS3DRotation());
        this.debugFolder.add(this.displayMesh.rotation, 'y').min(-Math.PI).max(Math.PI).step(0.01)
            .name('Rotation Y').onChange(() => this.updateCSS3DRotation());
        this.debugFolder.add(this.displayMesh.rotation, 'z').min(-Math.PI).max(Math.PI).step(0.01)
            .name('Rotation Z').onChange(() => this.updateCSS3DRotation());
        // 缩放控制
        this.debugFolder.add(this.css3dObject.scale, 'x').min(0.001).max(0.01).step(0.0001)
            .name('Scale').onChange((value) => {
                this.css3dObject.scale.setScalar(value);
            });
    }

    updateCSS3DPosition() {
        this.css3dObject.position.copy(this.displayMesh.position);

    }
    updateCSS3DRotation() {
        this.css3dObject.rotation.copy(this.displayMesh.rotation);
    }

    update() {

    }


    dispose() {
        if (this.css3dRenderer.domElement.parentNode) {
            this.css3dRenderer.domElement.parentNode.removeChild(this.css3dRenderer.domElement);
        }
    }
}